import React from "react";
import "../assets/styles/experience.css";
const Experience = ({ current }) => {
  return (
    <div className="my_skils_experience_container">
      <div className="my_skils_experience_content">
        <p className="my_skils_experience_present">2021 - Present</p>
        <p className="my_skils_experience_company">ARK Software Inc.</p>
      </div>
    </div>
  );
};

export default Experience;
